import { inject, injectable } from 'inversify';
import { DraftTeam } from '@Models';
import { Result } from '@Redux/type';
import {
  DraftTeamRepository,
  RequestDraftTeamSuccess,
} from '@Repository/tool/pairing';
import { TYPES } from '@Types';
import { ICrudEntityAction } from '@Redux/ICrudEntityAction';
import opponentTeamSlice from '@Redux/reducers/tool/pairing/opponentTeam.slice';

@injectable()
export class OpponentDraftTeamAction extends ICrudEntityAction<DraftTeam> {
  protected fetchDataSuccess(item: DraftTeam): {
    payload: DraftTeam;
    type: string;
  } {
    return opponentTeamSlice.actions.setTeam(item);
  }
  protected cacheDataSuccess(item: DraftTeam): {
    payload: DraftTeam;
    type: string;
  } {
    return opponentTeamSlice.actions.setTeam(item);
  }
  protected haveError(message: string): { payload: string; type: string } {
    return opponentTeamSlice.actions.setError(message);
  }
  protected areLoading(bool: boolean): { payload: boolean; type: string } {
    return opponentTeamSlice.actions.setLoading(bool);
  }

  @inject(TYPES.Repository.DraftTeamRepository)
  private _repository!: DraftTeamRepository;

  public loadOpponentTeamRequest =
    (): Result<void> => async (dispatch, getState) => {
      dispatch(this.areLoading(true));

      const state = getState();
      const team = state.opponentTeam.entity!;

      const response = await this._repository.get({
        teamId: team.id,
        locale: null,
      });

      if (this.handleFailure(response, dispatch)) return;

      const success = response as RequestDraftTeamSuccess;
      dispatch(this.fetchDataSuccess(success.payload));
      dispatch(this.areLoading(false));
    };
}
